// Metricas de negocio (GA4).
// Guard: si gtag no cargo (adblocker, red), el link funciona igual —
// medir jamas debe romper la navegacion.
export function registrarEvento(nombre, params) {
    if (typeof window.gtag === "function") {
        window.gtag("event", nombre, params);
    }
}

// Dominio de la tienda de cada marca aliada → valor del parametro `marca`.
const MARCAS_TIENDAS = [
    ["xiaomiperu.com", "xiaomi"],
    ["consumer.huawei.com", "huawei"],
    ["honorperu.pe", "honor"],
    ["tecstore.pe", "tecstore"],
    ["dji.pe", "dji"],
];

// Listener DELEGADO para los carruseles de tiendas: owl-carousel (jQuery) con
// loop:true clona los slides y los clones pierden los onClick de React. El
// click se captura en el contenedor y la marca se deduce del href, que si
// sobrevive al clonado.
export function registrarClickTiendaMarca(e) {
    const link = e.target.closest("a[href]");
    if (!link) return;
    const marca = MARCAS_TIENDAS.find(([dominio]) => link.href.includes(dominio));
    if (marca) {
        registrarEvento("click_tienda_marca", { marca: marca[1] });
    }
}
